<template>
  <div>
    <div class="form-group">
      <label v-if="survey.id != 552" :style="template.style.surveyBgColor ? {color: template.style.firstColor } : {color: black}"
             class="title-bold" for="nome">{{ questionText }}</label>
      <label v-else :style="template.style.surveyBgColor ? {color: template.style.firstColor } : 'color:#123654;'"
             class="title-bold" for="nome">{{ questionText }}</label>

      <p :style="template.style.surveyBgColor ? {color: template.style.secondColor } : {color: black}"
         class="observation">{{ questionObs }}</p>
      <input v-if="showListOther"
             type="text"
             class="form-control"
             :style="template.style.surveyBgColor ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white', color: 'black'}"
             :placeholder="getPlaceHolder"
             v-model="qtAnwser"
             v-on:click="showList"
             v-show="showInput"
      />
      <!--v-on:keydown="allKeys"-->
    </div>

    <span></span>

    <div
        class="q-buttonlist-selected"
        vs-align="center"
        vs-type="flex"
        vs-justify="space-around"
        v-show="showSelected"
    >

      <div v-for="(opt, index) in answerList" v-bind:key="index">
        <button
            :style="template.style.surveyBgColor ? {color: template.style.firstColor } : {color: '#212529' }"
            class="c-checkbox-container btn-check"
            @click="removeOption(opt)"
        >
          <span>{{ opt.replace("([", '').replace("])", '') }} </span>
          <input type="checkbox" checked="checked" disabled/>
          <!-- disabled to not uncheck -->
          <span class="checkmark"> </span>
        </button>
      </div>
    </div>

    <div class="sur-qtext">
      <div v-show="show" class="pt-2">
        <vs-row v-if="showListOther" v-for="(opt, index) in list" v-bind:key="opt.value">
          <vs-button
            :type="getBtnType(opt.text)"
            :ref="'btn_' + index"
            class="btn-block mb-2 btnOtion"
            :style="template.style.surveyBgColor ? {color: template.style.surveyTitleColor, borderColor: 'white'} : ''" 
            @click=" opt.text != otherText ? ChooseOption(opt.text, $event) : showOtherText(!showListOther)"
            >{{ opt.text }}</vs-button
          >
        </vs-row>
        <vs-row v-if="!showListOther">
          <input :placeholder="inputTextOther" v-model="inputOther" :style="template.style.surveyBgColor ? {backgroundColor: template.style.surveyBgColor, borderColor: template.style.surveyTextColor, color: template.style.surveyTextColor} : {borderColor: surveyBtnColor}" class="inputOther" type="text"/>
          <div class="divBtns">
            <p @click="showOtherText(!showListOther)" class="backButton"> {{ $t('back') }}</p>
            <button @click="saveAnswer(inputOther, $event)" :style="'background-color:'+ surveyBtnColor" class="acceptButton btnOtion"> Adicionar </button>
          </div>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import {mask} from "vue-the-mask";

export default {
  name: "Survey-Input-List",
  data: () => ({
    qtAnwser: "",
    inputTextOther: "",
    inputOther: "",
    dataOk: false,
    otherText: "",
    haveOtherOption: false,
    show: true,
    showInput: true,
    showList: true,
    qtdd: 0,
    showListOther: true,
    list: [],
    answerList: [],
    nMax: 1,
    nselected: 0,
  }),
  directives: {mask},
  props: {
    questionText: {type: String},
    questionObs: {type: String},
    questionId: {type: Number},
    options: [],
    config: {type: String},
  },
  computed: {
    showSelected: function () {
      if (this.nselected > 0) return true;
      else return false;
    },
    getPlaceHolder() {
      if (this.placeHolder) return this.placeHolder;
      else return this.$t('type_here');
    },
    survey() {
      return this.$store.state.template.survey;
    },
    surveyBtnColor() {
      return this.$store.state.template.style.surveyBtnColor;
    },
    surveyBtnTextColor() {
      return this.$store.state.template.style.surveyBtnTextColor;
    },
    btnTextColor() {
      return this.$store.state.template.style.btnTextColor;
    },
    template() {
      return this.$store.state.template;
    }
  },
  watch: {
    qtAnwser() {
      this.allKeys();
    },
  },
  created() {
    this.showInput = true;

    if (this.config) {
      if (this.config.includes("noinput")) {
        this.showInput = false;
        this.show = true;
      }

      if (this.config.includes("otherText")) {
        let configArray = this.config.split(";");
        for (let i = 0; i < configArray.length; i++) {
          if (configArray[i].startsWith('otherText=')) {
            const resultado = configArray[i];
            const index = resultado.indexOf('&');
            const value = resultado.substring(index + 1);
            this.inputTextOther = value.replaceAll('_', ' ');
          }
        }
      }
      if (this.config.includes("n:")) {
        var opts = this.config.split(";");
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].includes("n:")) {
            var r = opts[i].split(":");
            if (r[1] == "x") this.nMax = this.options.length;
            else this.nMax = r[1];
          }
        }
      }
    }
    // this.answerList = new Array(this.nMax);

    const regex = /otherText=([^&]+)/;
    const match = this.config.match(regex);
    this.otherText = match ? match[1] : null;

    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i].text.includes(this.otherText)) {
        this.haveOtherOption = true;
      }
    }

    if (this.config.includes("otherText")) {
      if (!this.haveOtherOption) {
        this.qtdd = this.options.length + 1
        let otherQuest = {
          value: this.qtdd,
          text: this.otherText,
          ilustration: null
        };
        this.options.push(otherQuest)
      }
    }

    //Verificar respostas anteriores:
    if (this.$store.getters.answerValue(this.questionId)) {
      var Anwser = this.$store.getters.answerValue(this.questionId);
      this.answerList = [];
      var s = Anwser.split(";");
      for (i = 0; i <= s.length - 1; i++) {
        if (s[i].includes("=")) {
          let answerSep = s[i].replaceAll("otherText=", "")
          answerSep = `([${answerSep}])`
          this.answerList.push(answerSep);
        } else {
          this.answerList.push(s[i])
        }
        this.nselected++;
      }
      this.multiSelectChanged();
      this.show = true;
    } else {
      this.list = this.options;
    }
  },
  methods: {
    getBtnType: function (value) {
      if (this.answerList.length != 0) {
        if (this.answerList.includes(value)) return "filled";
        else {
          return "border";
        }
      } else {
        return "border";
      }
    },
    allKeys() {
      this.list = [];
      //filtrar a lista
      for (var i = 0; i < this.options.length; i++) {
        //if (this.options[i].text.toUpperCase().startsWith(this.qtAnwser.toUpperCase().trim()))
        if (!this.answerList.includes(this.options[i].text))
          if (
              this.options[i].text
                  .toUpperCase()
                  .includes(this.qtAnwser.toUpperCase().trim())
          )
            this.list.push(this.options[i]);
      }
      //this.show = true;
      //this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
    },
    mountAnswer: function () {
      return this.answerList.join(';')
    },
    removeOption(opt) {
      let ln = []
      //somente remontamos a lista
      for (let i = 0; i < this.answerList.length; i++) {
        if (this.answerList[i] != opt) ln.push(this.answerList[i]);
      }

      this.answerList = ln;
      this.multiSelectChanged();

      this.nselected--;
      var resp = this.mountAnswer();
      this.$emit("AnswerChanged", resp, this.questionId);
    },

    multiSelectChanged() {
      this.list = [];
      //somente remontamos a lista
      for (var i = 0; i < this.options.length; i++) {
        if (!this.answerList.includes(this.options[i].text))
          this.list.push(this.options[i]);
      }
    },

    showList() {
      this.show = true;
    },

    showOtherText(show) {
      this.showListOther = show
    },

    saveAnswer(text, event) {
      if (text != "") {
        let answer = `([${text}])`
        this.ChooseOption(answer, event)
      } else {
        this.$vs.notify({
          color: "rgb(255, 130, 0)",
          title: `Atenção!`,
          text: "Não é possível salvar uma opção em branco",
        });
      }
    },

    CheckEscape(value) {
      var escape = false;
      if (this.config.includes("escape=")) {
        var opts = this.config.split(";");

        for (var i = 0; i < opts.length; i++) {
          if (opts[i].includes("escape=")) {
            var r = opts[i].split("=");
            if (r[1].includes(value)) escape = true;
          }
        }
      }
      return escape;
    },
    ChooseOption(opt, event) {
      if (this.nselected >= this.nMax) {
        this.$nextTick(() => {
          document.querySelector(".btn-check").focus();
          let elems = document.getElementsByClassName("isActive");
          elems.forEach((el) => el.classList.remove("isActive active"));
        });
        this.$vs.notify({
          color: "rgb(255, 130, 0)",
          title: `Atenção!`,
          text: "Número máximo de respostas atingido. Desmarque uma opção.",
        });

        return false;
      }
      //verificar se deve de fato avançar quando a opçao é selecionada e o max é 1
      if (this.nMax === 1 || this.CheckEscape(opt)) {
        this.qtAnwser = opt;
        this.answerList = [];
        this.answerList.push(opt);
        this.nselected++;
        this.$emit("QuestionAnwered", this.qtAnwser, this.questionId);
      } else {
        let resp = ""
        if (this.nselected <= this.nMax) {
          this.nselected++
          this.answerList.push(opt)
          resp = this.mountAnswer()
          this.multiSelectChanged()
          if (resp.includes("([") && resp.includes("])")) {
            let arr = resp.split(";");
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].includes("([") && arr[i].includes("])")) {
                arr[i] = "otherText=" + arr[i].replace(/[(\[\])]/g, '');
              }
            }
            resp = arr.join(";")
            resp = resp.trim()
          }
          if (this.nselected == this.nMax) {
            this.$emit("QuestionAnwered", resp, this.questionId);
          } else {
            this.$emit("AnswerChanged", resp, this.questionId);
          }
        } else {
          //    this.multiSelectChanged();
          event.stopPropagation();
        }
      }
    },
  },
};
</script>

<style scoped>
.inputOther {
  width: 600px;
  height: 50px;
  border-radius: 5px;
  padding-left: 15px;
  outline: none;
  border: black 1px solid;
}

.divBtns {
  margin-top: 12px;
  width: 600px;
  height: 40px;
  display: flex;
  justify-content: flex-end;
}

.backButton {
  width: 120px;
  height: 50px;
  border-radius: 5px;
  border: none;
  margin-right: 10px;
  background: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.acceptButton {
  filter: brightness(100%);
  background: white;
  width: 120px;
  height: 50px;
  border-radius: 5px;
  border: none;
}

.btn-check {
  border: none;
  background-color: transparent;
}

.title-bold {
  font-family: 'OxaniumBold';
}

.btn-check:hover,
.btn-check:focus {
  background-color: transparent !important;
}

.btn-check:focus input ~ .checkmark {
  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.5);
}

button.c-checkbox-container.btn-check:hover span {
  color: var(--survey-text-color) !important;
}

/* .question .form-group > label {
  font-size: 1.25rem;
  letter-spacing: -0.48px;
  font-weight: bold;
}
.question .form-group input {
  border: none;
  border-left: 2px solid #038835 !important;
  font-size: 1.5rem;
  margin: 1rem 0 0;
}
.question .form-group input:focus {
  border: none !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255) !important;
  border-left: 2px solid #038835 !important;
}
.question form .btn-primary {
  width: 50% !important;
  display: inline-block !important;
}
.question form .instrucao {
  display: inline-block;
}

.iconx {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: solid 1px #dfe2e6;
  color: #dfe2e6;
}

.btnOtion {
  width: 100%;
}

.q-title {
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #40424a;
}

.q-list-answer {
  width: 351px;
  height: 40px;
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #40424a;
  display: inline-block;
  vertical-align: middle;
}

.q-text-answer .text-style-1 {
  color: #038835;
} */
</style>
